import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Button from '@classify/react-core-components/Button';
import Callout from '@classify/react-core-components/Callout';
import Box from '@classify/react-core-components/Box';
import Snackbar from '@classify/react-core-components/Snackbar';
import { styled } from '@classify/react-core-components/styles';
import type { Theme } from '@classify/react-core-components/styles';
import type { CompletionState, EmbeddedChapterTranslations } from '../../../types';
const FooterRoot = styled(Box)(({
  theme
}: {
  theme: Theme;
}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2)
}));
type EmbeddedChapterFooterProps = {
  completionState: CompletionState;
  onMarkAsComplete: () => void;
  translations: EmbeddedChapterTranslations;
};
const EmbeddedChapterFooter = t0 => {
  const $ = _c(19);
  const {
    completionState,
    onMarkAsComplete,
    translations
  } = t0;
  const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== completionState) {
    t1 = () => {
      if (completionState === "error") {
        setIsErrorSnackbarOpen(true);
      }
    };
    t2 = [completionState];
    $[0] = completionState;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (completionState === "completed") {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        width: "100%"
      };
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== translations.validatedChapter) {
      t4 = <><FooterRoot><Callout type="success" sx={t3}>{translations.validatedChapter}</Callout></FooterRoot></>;
      $[4] = translations.validatedChapter;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const t3 = completionState === "loading";
  const t4 = completionState === "loading";
  let t5;
  if ($[6] !== onMarkAsComplete || $[7] !== t3 || $[8] !== t4 || $[9] !== translations.loadingAriaLabel || $[10] !== translations.validateChapter) {
    t5 = <FooterRoot><Button variant="secondary" onClick={onMarkAsComplete} isLoading={t3} loadingAriaLabel={translations.loadingAriaLabel} disabled={t4}>{translations.validateChapter}</Button></FooterRoot>;
    $[6] = onMarkAsComplete;
    $[7] = t3;
    $[8] = t4;
    $[9] = translations.loadingAriaLabel;
    $[10] = translations.validateChapter;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== completionState || $[13] !== isErrorSnackbarOpen || $[14] !== translations.validationError) {
    t6 = completionState === "error" ? <Snackbar isOpen={isErrorSnackbarOpen} message={translations.validationError} type="error" onClose={() => setIsErrorSnackbarOpen(false)} /> : null;
    $[12] = completionState;
    $[13] = isErrorSnackbarOpen;
    $[14] = translations.validationError;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default EmbeddedChapterFooter;